export const filtersDataFormatter = (services) => {
    return services?.map((item) => {
        return {
            title: item?.name ? item?.name : '-',
            id: item?.id,
            services: item?.subServices?.length > 0 ?
                item?.subServices?.map((subItem) => {
                    return ({
                        title: subItem?.name,
                        id: subItem?.id,
                        services: subItem?.subServices?.length > 0 ?
                            subItem?.subServices?.map((subSubItem) => {
                                return ({
                                    id: subSubItem?.id,
                                    name: subSubItem?.name
                                })
                            }) : []
                    })
                }) : []
        }
    })
}